import React, { useEffect } from 'react';
import {
  Button,
  DatePicker,
  FormField,
  Select,
} from '@vwfs-bronson/bronson-react';
import { useAppDispatch } from "../../../redux/hooks";
import { FilterByDateRange } from '../../../redux/slices/types';
import './style.css';
import { resetAndFetchPayments } from '../../../redux/slices/payments-slice';
import { FilterTripServiceProviderTypes, TripServiceProvider, TripServiceProviderKeys } from '../payments-data/types';
import { useSearchParams } from "react-router-dom";
import { resetErrorDialog, setErrorDialog } from '../../../redux/slices/notification-slice';
import { BillingEntryState, BillingEntryStateKeys, FilterPaymentState } from '../../../utils/trip-invoice-utils';

export interface PaymentsDataFilterProps {
  initPaymentState?: string;
  initMSP?: string;
  initStartDate?: string;
  initStopDate?: string;
}

export default function PaymentsDataFilter({ initPaymentState, initMSP, initStartDate, initStopDate }: PaymentsDataFilterProps) {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [paymentState, setPaymentStateFilter] = React.useState(null);
  const [serviceProvider, setServiceProviderfilter] = React.useState(null);
  const [dateRange, setDateRangeFilter] = React.useState({
    start: '',
    stop: ''
  });

  useEffect(() => {
    if (initPaymentState) {
      setPaymentStateFilter(initPaymentState);
    }

    if (initMSP) {
      setServiceProviderfilter(initMSP);
    }

    if (initStartDate && initStopDate) {
      setDateRangeFilter({
        start: initStartDate,
        stop: initStopDate
      })
    }
  }, [initPaymentState])

  function setDateRange(dateRange: FilterByDateRange) {
    setDateRangeFilter(dateRange);
    dispatch(resetErrorDialog());
  }

  function setPaymentState(paymentState: FilterPaymentState) {
    setPaymentStateFilter(paymentState);
    dispatch(resetErrorDialog());
  }

  function setServiceProvider(serviceProvider: FilterTripServiceProviderTypes) {
    setServiceProviderfilter(serviceProvider);
    dispatch(resetErrorDialog());
  }

  function handleOnDateRangeChange(e) {
    if (e.includes('bis')) {
      const SPLIT_FLAG = ' bis ';
      const dates = e.split(SPLIT_FLAG);
      setDateRange({
        start: dates[0],
        stop: dates[1],
      })

    }
  }

  function handleNewSearch() {
    if (!paymentState) {
      dispatch(setErrorDialog({
        code: 'MISSING_PAYMENT_SEARCH_FIELD',
        title: 'Unable to search',
        message: 'Payments searach not possible, select valid payment state.'
      }));
      return;
    }

    dispatch(resetAndFetchPayments({
      paymentState,
      serviceProvider,
      formDate: dateRange.start,
      toDate: dateRange.stop
    }));

    const params = new URLSearchParams();
    if (paymentState) {
      params.append('state', paymentState);
    }
    if (serviceProvider) {
      params.append('msp', serviceProvider);
    }
    if (dateRange?.start && dateRange?.stop) {
      params.append('start', dateRange?.start);
      params.append('stop', dateRange?.stop);
    }

    setSearchParams(params, { replace: true })
  }

  return (
    <div data-testid="bookingsFilter" key="bookingsFilter" className="filter-group">

      <FormField
        labelText="Select Payment State"
        type="input"
        testId='testSelectPaymentState'
      >
        <Select onChange={(e) => setPaymentState(e.target.value as FilterPaymentState)} value={paymentState || undefined}>
          <Select.Item value={''}>None</Select.Item>
          {BillingEntryStateKeys.map(key => <Select.Item key={key} value={key}>{BillingEntryState[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        labelText="Select Pickup Date Range"
        type="input"
        testId='testSelectDateRange'
      >
        <div style={{ margin: 'auto' }}>
          <DatePicker
            value={initStartDate && initStopDate ? `${initStartDate} bis ${initStopDate}` : undefined}
            testId='testDatePicker'
            key="paymentDataRangeSelect"
            mode='range'
            onChange={handleOnDateRangeChange}
          />
        </div>
      </FormField>

      <FormField
        labelText="Select Service Provider"
        type="input"
        testId='testSelectMSP'
      >
        <Select onChange={(e) => setServiceProvider(e.target.value as FilterTripServiceProviderTypes)} value={serviceProvider || undefined}>
          <Select.Item value={''}>None</Select.Item>
          {TripServiceProviderKeys.map(key => <Select.Item key={key} value={TripServiceProvider[key]}>{TripServiceProvider[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        style={{ marginTop: '30px' }}
        type="input"
      >
        <Button
          onClick={handleNewSearch}
          key="resetBookingFilters"
          testId='testSearchBtn'
        >
          Search
        </Button>
      </FormField >
    </div >
  );
}
